module.exports = __webpack_public_path__ + "img/MARTA.10a6c309.jpeg";